import styled from "styled-components";
import { Flex, GridContainer } from "../../common/Layouts/styles";
import {
  CTAColor,
  fadingTextColor,
  primaryColor,
  secondaryColor,
} from "../../styles/styles";

export const MainBlockContainter = styled(Flex)`
  flex-direction: column;
  gap: 1vw;
  position: relative;
  /* height: 101vh; */
  overflow: hidden;
  margin: 4vw 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    height: unset;
  }
`;

export const BlockContainer = styled(Flex)`
  position: relative;
  z-index: 1;
  padding: 0 2vw;
  font-size: .8em;
`;

export const Container = styled(Flex)`
  padding: 0 2vw;
  gap: 2rem;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding-bottom: 44vh;
  }
`;

export const OurStack = styled(Flex)`
  background-color: white;
  border-radius: 8px;
  padding: 1.4vw 2vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    font-size: 3em;
  }
`;

export const OurStackTitle = styled("h3")`
  color: black;
  font-size: 3em;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: unset;
    text-align: left;
    font-size: 8em;
    color: white;
    margin-bottom: 1vw;
  }
`;

export const OurStackInnerTitle = styled("h3")`
  color: black;
`;

export const StackItem = styled(Flex)`
  color: ${fadingTextColor};
  font-size: 2em;
  padding-right: 2vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 1vw;
  }
`;

export const Heading = styled("h1")`
  font-size: 7.4vw;
  font-weight: 300;
  font-family: greyBeard;
  text-transform: uppercase;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 22em;
    margin-top: 16vw;
    margin-bottom: 16vw;
  }
`;

export const NumbersTitle = styled("h3")`
  font-size: 4em;
  margin: 0.6vw 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 10em;
    margin: 1vw 0;
  }
`;

export const SubContainer = styled(Flex)`
  flex-direction: column;
  font-size: 7vw;
  margin-bottom: 3rem;
  line-height: 92px;
`;

export const SpinningContainer = styled(Flex)`
  background-color: ${secondaryColor};
  /* padding: 1vw 0; */
  padding-left: 1.6vw;
  border-radius: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 2vw;
  }
`;

export const Marquee = styled(Flex)`
  width: 100%;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  height: 2.4vw;
  padding: 1.6vw 0;

  &:after {
    content: "";
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-image: linear-gradient(
      to right,
      rgba(39, 39, 43, 0) 85%,
      rgba(39, 39, 43, 1) 100%
    );
    width: 100%;
    height: 8em;
  }

  &:before {
    content: "";
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-image: linear-gradient(
      to left,
      rgba(39, 39, 43, 0) 85%,
      rgba(39, 39, 43, 1) 100%
    );
    width: 100%;
    height: 8em;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 3vw 0;
  }
`;

export const Track = styled(Flex)`
  justify-content: center;
  position: absolute;
  white-space: nowrap;
  animation: marquee 12s linear infinite reverse;
  min-width: 100%;
  flex: none;

  @keyframes marquee {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;

export const Content = styled(Flex)`
  align-items: center;
`;

export const MainBlock = styled(Flex)`
  border-radius: 8px;
  flex-direction: column;
  background-color: ${secondaryColor};
  padding: 1vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 3vw;
  }
`;

export const FlexWrap = styled(Flex)`
  flex-wrap: wrap;
  gap: 0.6vw;
`;

export const FlexColumn = styled(Flex)`
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 5em;
  }
`;

export const ProjectNumbersBlock = styled(Flex)`
  background-color: ${secondaryColor};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-grow: 1;
  padding: 1vw 0;
  border-radius: 8px;
`;

export const AdditionalInfoText = styled("h4")`
  color: #6f6f6f;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 4em;
  }
`;
export const ProjectNumbersH = styled("h2")`
  color: ${CTAColor};
  font-weight: 400;
  font-size: 9em;
  word-wrap: break-word;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 20em;
  }
`;

export const MiniAdditional = styled(ProjectNumbersH)`
  font-size: 3em;
  margin-bottom: 0.8vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 8em;
    margin-bottom: 2vw;
  }
`;

export const AcademyGridContainer = styled(GridContainer)`
  background-color: ${secondaryColor};
  border-radius: 8px;
  padding: 1.2vw 1.05vw;
  position: relative;
`;

export const AcademyP = styled("p")`
  color: ${fadingTextColor};
  font-size: 0.9vw;
`;

export const AbsoluteWrapper = styled("div")`
  position: absolute;
  width: 100%;
  z-index: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    bottom: 57%;
    transform: translateY(20%);
    scale: 3;
  }
`;

export const WavesImg = styled("img")`
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    bottom: 100%;
  }
`;

export const ArrowAbsoluteWrapper = styled("div")`
  /* @keyframes active {
    0% {
      bottom: 4vh;
    }
    100% {
      bottom: 5vh;
    }
  } */

  position: fixed;
  z-index: 10;
  bottom: 4vh;
  left: 50%;
  transform: translateX(-50%);
  /* animation: active ease-in .4s infinite alternate; */
`;

export const ArrowWrapper = styled("div")`
  background-color: ${secondaryColor};
  border: 1px solid ${primaryColor};
  padding: 8px;
  border-radius: 50%;
`;
